// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {DocumentProcessorScreenLayout} from 'app_components/screens/admin/documentProcessor'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import DocumentProcessorService from 'app_services/admin/documentProcessor/documentProcessorService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { DocumentProcessorType, DocumentProcessorTypeUrl, IDocumentProcessorItem, IDocumentProcessorResponse } from 'app_types/admin/documentProcessor/documentProcessorTypes'
import moment from 'moment'

// @end

// @ADD Component types
interface IDocumentProcessorScreenProps {
  match?: any
}
interface IDocumentProcessorScreenState {
  status: null | 'loading' | 'error'
  itemList: IDocumentProcessorItem[]
  pagination: IPagination,
  filters?: {document_type?: DocumentProcessorType}
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class DocumentProcessorScreen extends Component<IDocumentProcessorScreenProps, IDocumentProcessorScreenState> {

  public moduleName: string = 'module:document_processor'
  private permission: PermissionService
  private itemService: DocumentProcessorService
  private i18nUtil: I18nUtil
  private screenNotifications: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IDocumentProcessorScreenProps) {
    super(props)
    this.state = {
      status: 'loading',
      itemList: [],
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
      filters: {
        document_type: undefined
      }
    }

    this.permission = new PermissionService(this.moduleName)
    this.itemService = new DocumentProcessorService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    const params: any = {}
    if (this.props?.match?.params?.document_type) {
      if (Object.keys(DocumentProcessorTypeUrl).includes(this.props.match.params.document_type)) {
        //@ts-ignore
        const type = DocumentProcessorTypeUrl[this.props.match.params.document_type]
        params['document_type'] = type
        this.setState({
          filters: {
            document_type: type
          }
        })
      }
    }
    await this.getList(params)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onPageChange = async (page: number) => {
    this.getList({ page })
  }

  getList = async (params?: any) => {
    this.setState({ status: 'loading' })

    const httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      document_type: params?.document_type ? params?.document_type : this.state.filters?.document_type,
      select: 'id userId status type docPath created_at',
      sort: {
        field: 'created_at',
        direction: 'desc'
      }
    }

    if (params?.search) {
      httpParams.search = params?.search
    }

    let itemList: IDocumentProcessorResponse | null = await this.itemService.list(httpParams)

    if (itemList?.status_code === 'success') {
      const items: IDocumentProcessorItem[] = itemList?.documentQueue.reduce((accum: IDocumentProcessorItem[], element) => {
        let _item: IDocumentProcessorItem = {...element}
        if (element.created_at) {
          _item.created_at = moment(element.created_at).format('YYYY-MM-DD HH:mm:ss')
        }
        if (element.status) _item.statusLabel = `${this.i18nUtil.getTranslate(`screens.documentProcessor.status.${element.status}`)}`
        if (element.type) _item.typeLabel = `${this.i18nUtil.getTranslate(`screens.documentProcessor.type.${element.type}`)}`

        accum.push(_item)
        return accum
      }, [])
      this.setState({
        itemList: items,
        pagination: {
          total: itemList?.total_register,
          perPage: itemList?.nPerPage,
          page: itemList?.pageNumber,
        },
        status: null,
      })

    } else {
      this.setState({ status: 'error' })
    }
  }

  remove = async (id: string) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('screens.documentProcessor.delete.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('screens.documentProcessor.delete.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,

      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          // this.setState({ status: 'loading' })

          const removeUser = await this.itemService.remove(id)

          if (removeUser) {
            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate('components.screen_notifications.delete')}`,
              },

              {
                position: 'bottom-right',
              },
            )

            await this.getList()
          }
        }
      })
    }
  }

  render() {
    return(
      <DocumentProcessorScreenLayout
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        itemList={this.permission.check('permission:document_processor_list', this.state.itemList)}
        remove={this.permission.check('permission:document_processor_delete', this.remove)}
        status={this.state.status}
      />
    )
  }
}

export default connect(mapStatesToProps)(DocumentProcessorScreen)
